import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { Report } from '../Components/SimulationReport/Identification'

type Store = {
  isReportGenerated: boolean
  isReportGeneratedEnabled: boolean
  isNifSearched: boolean
  setIsNifSearched: (value: boolean) => void
  isProspect: boolean
  setIsProspect: (value: boolean) => void
  setReportGenerated: (value: boolean) => void
  setIsReportGeneratedEnabled: (value: boolean) => void
  isSentEmail: boolean
  setSentEmail: (value: boolean) => void
  report: Partial<Report>
  setReport: (report: Partial<Report>) => void
}

export const useReportStore = create<Store>()(
  devtools(
    (set, get) => ({
      isReportGenerated: false,
      isReportGeneratedEnabled: true,
      report: {
        vatNumber: '',
        name: '',
        phone: '',
        email: '',
        packs: [],
        phoneList: [],
      },
      isNifSearched: false,
      setIsNifSearched: (isNifSearched) => set({ isNifSearched }),
      isProspect: false,
      setIsProspect: (isProspect) => set({ isProspect }),
      setReportGenerated: (isReportGenerated) => set({ isReportGenerated }),
      setIsReportGeneratedEnabled: (isReportGeneratedEnabled) =>
        set({ isReportGeneratedEnabled }),
      isSentEmail: false,
      setSentEmail: (isSentEmail) => set({ isSentEmail }),
      setReport: (_report) =>
        set(() => {
          const newData = {
            ...get().report,
            ..._report,
          }

          return { report: newData }
        }),
    }),
    { name: 'ReportStore' },
  ),
)
